<template>
  <Teleport to="body" v-if="visible">
    <div style="
        position: fixed;
        top: 2px;
        right: 2px;
        background: #0d0971;
        color: white;
        padding: 70px;
        border-radius: 100px 0px 0px 100px;
        max-height: 70vh;
        overflow-y: auto;
        z-index: 9999;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
      ">
      <!-- Close Button -->
      <button @click="emit('update:visible', false)" style="
          position: absolute;
          top: 16px;
          right: 16px;
          background: none;
          border: none;
          padding: 0;
          cursor: pointer;
        " aria-label="Close">
        <img src="../assets/close.png" alt="Close" style="width: 30px; height: 30px; display: block" />
      </button>

      <div style="
          display: grid;
          grid-auto-flow: column;
          grid-auto-rows: min-content;
          grid-template-rows: repeat(9, 1fr);
          gap: 10px;
          justify-content: end;
        ">
        <div v-for="lang in languages" :key="lang.code" @click="handleClick(lang)" style="
            display: flex;
            align-items: center;
            gap: 8px;
            padding: 16px 18px;
            border-radius: 4px;
            transition: background-color 0.2s;
            user-select: none;
            position: relative;
          " @mouseover="lang.enabled ? (hovered = lang.code) : null" @mouseleave="hovered = null" :style="{
            backgroundColor:
              locale === lang.code ? 'rgba(255,255,255,0.3)' : (hovered === lang.code ? 'rgba(255,255,255,0.2)' : 'transparent'),
            cursor: lang.enabled ? 'pointer' : 'not-allowed',
            color: lang.enabled ? 'white' : '#999',
            border: locale === lang.code ? '2px solid rgba(255,255,255,0.6)' : '2px solid transparent',
          }">
          <!-- 选中标记 - 放在国旗前面 -->
          <span v-if="locale === lang.code" style="
            color: white;
            font-size: 20px;
            font-weight: bold;
            min-width: 20px;
          ">✓</span>
          <span v-else style="min-width: 20px;"></span>
          <img :src="lang.flag" alt="" :style="{
            width: '40px',
            height: '30px',
            borderRadius: '2px',
            boxShadow: '0 0 2px #000',
            filter: lang.enabled ? 'none' : 'grayscale(100%) opacity(0.5)',
          }" />
          <span style="font-size: 18px; font-weight: locale === lang.code ? 'bold' : 'normal'">{{ lang.name }}</span>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { ref, defineProps, defineEmits } from "vue";
import { useI18n } from 'vue-i18n';

const { locale } = useI18n();

const props = defineProps({
  visible: {
    type: Boolean,
    required: true,
  },
  languages: {
    type: Array,
    required: true,
    default: () => []
  }
});

const emit = defineEmits(["update:visible", "select-language"]);

const hovered = ref(null);

// 添加调试信息
console.log('🔍 LanguageDialog props:', props);
console.log('🔍 Languages received:', props.languages);

function handleClick(lang) {
  if (!lang.enabled) {
    alert(`语言 ${lang.name} 暂不支持`);
    return;
  }
  emit("select-language", lang);
  console.log("in dialog 你选择的语言是：", lang);
  emit("update:visible", false);
}
</script>
